export const ContactTypes = {
  SEND_EMAIL: "contact/SEND_EMAIL",
};

export const sendEmail = (payload) => ({
  type: ContactTypes.SEND_EMAIL,
  payload,
});
